import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { toast } from "./hooks/use-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import AppShell from "./app/AppShell";
import DashboardHome from "./app/DashboardHome";
import QRManager from "./app/QRManager";
import QRStats from "./app/stats/QRStats";
import CompanyStats from "./app/stats/CompanyStats";
import ProductPage from "./pages/ProductPage";
import Checkout, { CheckoutResult } from "./pages/Checkout";
import LegalPage from "./pages/LegalPage";
import PagesManager from "./app/PagesManager";
import MenuManager from "./app/MenuManager";
import MenuEditor from "./app/MenuEditor";
import PageEditor from "./app/PageEditor";
import AdminPanel from "./app/AdminPanel";
import Team from "./app/Team";
import Services from "./app/Services";
import PromotionsManager from "./app/PromotionsManager";
import PublicPage from "./public/PublicPage";
import PublicMenu from "./public/PublicMenu";
import Gone from "./public/Gone";
import GuideIndex, { GuideArticle } from "./pages/Guide";
import SeoAdmin from "./app/seo/SeoAdmin";
import Analytics from "./seo/Analytics";
import SitePage from "./pages/SitePage";
import { StickyCta } from "./components/Commercial";
import BackToTop from "./components/BackToTop";
import MenuCheck from "./pages/MenuCheck";
import MenuCheckAdmin from "./app/MenuCheckAdmin";
import PrintKit from "./app/PrintKit";
import Builder from "./app/builder/Builder";
import PageStats from "./app/stats/PageStats";
import MiniSiteAdmin from "./app/MiniSiteAdmin";

function Marketing({ children, hideFooter }) {
  return (<><Navbar /><main className="min-h-screen">{children}</main>{!hideFooter && <Footer />}<div className="h-16 lg:hidden" /><StickyCta /><BackToTop offset={typeof window !== "undefined" && window.innerWidth < 1024 ? 84 : 24} /></>);
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  React.useEffect(() => {
    const onReject = (ev) => { const m = ev?.reason?.qoraMessage; if (m) { ev.preventDefault(); toast({ title: "Errore", description: m, variant: "destructive" }); } };
    window.addEventListener("unhandledrejection", onReject);
    return () => window.removeEventListener("unhandledrejection", onReject);
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Marketing><Landing /></Marketing>} />
            <Route path="/prezzi" element={<Marketing><Pricing /></Marketing>} />
            <Route path="/qora-qr" element={<Marketing><ProductPage product="qr" /></Marketing>} />
            <Route path="/qora-link" element={<Marketing><ProductPage product="link" /></Marketing>} />
            <Route path="/qora-menu" element={<Marketing><ProductPage product="menu" /></Marketing>} />
            <Route path="/qora-minisite" element={<Marketing><ProductPage product="minisite" /></Marketing>} />
            <Route path="/qora-complete" element={<Marketing><ProductPage product="complete" /></Marketing>} />
            <Route path="/menu-check" element={<Marketing><MenuCheck /></Marketing>} />
            {["faq", "funzionalita", "chi-e-qora"].map((pg) => <Route key={pg} path={`/${pg}`} element={<Marketing><SitePage path={`/${pg}`} /></Marketing>} />)}
            <Route path="/guide" element={<Marketing><GuideIndex /></Marketing>} />
            <Route path="/guide/:slug" element={<Marketing><GuideArticle /></Marketing>} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/esito" element={<CheckoutResult />} />
            {["privacy", "termini", "cookie", "informativa-pagamenti"].map((pg) => <Route key={pg} path={`/${pg}`} element={<Marketing><LegalPage page={pg} /></Marketing>} />)}
            <Route path="/login" element={<Login />} />
            <Route path="/registrati" element={<Register />} />

            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<DashboardHome />} />
              <Route path="qr" element={<QRManager />} />
              <Route path="qr/:id/statistiche" element={<QRStats />} />
              <Route path="statistiche" element={<CompanyStats />} />
              <Route path="pagine" element={<PagesManager />} />
              <Route path="pagine/:id" element={<Builder />} />
              <Route path="pagine/:id/statistiche" element={<PageStats />} />
              <Route path="admin/minisite" element={<MiniSiteAdmin />} />
              <Route path="menu" element={<MenuManager />} />
              <Route path="menu/:id" element={<MenuEditor />} />
              <Route path="team" element={<Team />} />
              <Route path="servizi" element={<Services />} />
              <Route path="promozioni" element={<PromotionsManager />} />
              <Route path="admin" element={<AdminPanel />} />
              <Route path="admin/seo" element={<SeoAdmin />} />
              <Route path="admin/menu-check" element={<MenuCheckAdmin />} />
              <Route path="print-kit" element={<PrintKit />} />
            </Route>

            <Route path="/p/:slug" element={<PublicPage />} />
            <Route path="/m/:id" element={<PublicMenu />} />
            <Route path="/gone" element={<Gone />} />
          </Routes>
          <Toaster />
          <Analytics />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
